import React, { useState } from "react";
import PropTypes from "prop-types";
import { css } from "glamor";

import Drawer from "../drawer/index.js";
import Icons from "../../icons/index.js";
import { useNiUi } from "../../providers/NiUiProvider.js";

import styles from "./styles.module.scss";

const Header = ({ controls = [], logo, mobileMenu, navItems = [] }) => {
  const { hamburgerOpen, setHamburgerOpen, scrollDepth } = useNiUi();

  const headerScrollDepthRule = css({
    "&:after": {
      width: `${scrollDepth}%`
    }
  });

  return (
    <header className={`${styles.header} ${headerScrollDepthRule}`}>
      <div className={styles.headerLogo}>{logo}</div>
      <nav className={styles.headerNav}>{navItems}</nav>
      <div className={styles.headerControls}>
        {controls.map((control) => control)}
      </div>
      <div className={styles.headerMobileMenuButton}>
        {mobileMenu && (
          <Drawer
            closeDrawer={hamburgerOpen}
            drawerHeading={logo}
            drawerPosition="left"
            openDrawerButtonProps={{
              corners: "sharp",
              icon: <Icons.MenuIcon />,
              onClick: () => setHamburgerOpen(!hamburgerOpen),
              profiling: "borderless"
            }}
          >
            {mobileMenu}
          </Drawer>
        )}
      </div>
    </header>
  );
};

Header.propTypes = {
  controls: PropTypes.arrayOf(PropTypes.node),
  logo: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  mobileMenu: PropTypes.node, // todo: remove mobileMenu as a prop in future
  navItems: PropTypes.arrayOf(PropTypes.node).isRequired
};

export default Header;
